/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import SubjectStepModel from 'cio/models/subject-step';

type CollectionQueryArgs = {
  step: SubjectStepModel;
};

export default class CollectionQuery extends Component<CollectionQueryArgs> {
  get attributeUpdateSuccess() {
    let { status } = this.args.step;

    if (status?.queryCollection == null) {
      // older subject steps do not have status
      return false;
    }

    return !status.queryCollection.hasFailures;
  }

  get attributeUpdateFailed() {
    let { status } = this.args.step;

    if (status?.queryCollection == null) {
      // older subject steps do not have status
      return false;
    }

    return status.queryCollection.hasFailures;
  }

  get attributeUpdateSkipped() {
    let { status } = this.args.step;

    if (status?.queryCollection == null) {
      // older subject steps do not have status
      return false;
    }

    return status.queryCollection.updatedCount === 0 && !status.queryCollection.hasFailures;
  }
}
